import React from 'react';

const PrivacyPolicy = () => {
  return (
    <div className="max-w-4xl mx-auto px-4 py-8 text-gray-800 bg-white">
      <h1 className="text-3xl font-bold mb-4">Privacy Policy</h1>
      <p className="mb-4">Last updated: July 14, 2025</p>

      <p className="mb-4">
        At <strong>Jivan Gaming</strong>, accessible from https://jivangaming.in, we respect your privacy. This Privacy Policy outlines how we collect, use, and protect your personal information.
      </p>

      <h2 className="text-xl font-semibold mt-6 mb-2">Information We Collect:</h2>
      <ul className="list-disc pl-6 mb-4">
        <li>Name, email address, mobile number, billing/shipping address</li>
        <li>Payment details (processed securely via third-party gateways)</li>
        <li>Usage data and cookies for improving site experience</li>
      </ul>

      <h2 className="text-xl font-semibold mt-6 mb-2">How We Use Your Information:</h2>
      <ul className="list-disc pl-6 mb-4">
        <li>Process transactions</li>
        <li>Send order updates and customer support</li>
        <li>Improve our website and services</li>
        <li>Comply with legal obligations</li>
      </ul>

      <h2 className="text-xl font-semibold mt-6 mb-2">Data Protection:</h2>
      <p className="mb-4">We use SSL encryption and secure servers to protect your data. We do not sell or share your personal information with third parties without consent.</p>

      <h2 className="text-xl font-semibold mt-6 mb-2">Your Rights:</h2>
      <ul className="list-disc pl-6 mb-4">
        <li>Access, update, or delete your personal data</li>
        <li>Opt out of marketing communications</li>
      </ul>

      <h2 className="text-xl font-semibold mt-6 mb-2">Contact Us:</h2>
      <p>Email us at: <a href="mailto:jivanpawar023@gmail.com" className="text-blue-500 underline">jivanpawar023@gmail.com</a></p>
    </div>
  );
};

export default PrivacyPolicy;
